import { render, staticRenderFns } from "./Cta.vue?vue&type=template&id=d794468e&scoped=true&"
import script from "./Cta.vue?vue&type=script&lang=ts&"
export * from "./Cta.vue?vue&type=script&lang=ts&"
import style0 from "./Cta.vue?vue&type=style&index=0&id=d794468e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d794468e",
  null
  
)

export default component.exports